<generic-page *ngIf="_appService.CoreCommonLiterals && _gearAppService?.GearMonitorLiterals"
  [title]="(!displayOnModal || communicationID) ?  'Comunicación'+ ' - ' + ((communicationID) ? _appService.CoreCommonLiterals.Edit : _appService.CoreCommonLiterals.Add) : ''"
  [errorMessage]="!displayOnModal ? _errorBackEnd: ''" 
  [submitButtonText]="!displayOnModal ? _appService.CoreCommonLiterals.ButtonSave : ''"
  (onSubmit)="!displayOnModal ? onSave(formElement): null" 
  [cancelButtonText]="!displayOnModal ? _appService.CoreCommonLiterals.ButtonCancel : ''" 
  [isGeneric]="true">
  <form #formElement="ngForm" autocomplete="off">
    <div class="form-container">
      <div class="form-group">
        <label for="dateTimeCreated">Fecha y hora</label>
        <lib-datepicker
        name="dateTimeCreated"
        id="dateTimeCreated"
        [useTime]="true"
        [(ngModel)]="_communication.DateTimeCreated"
        [maxDate]="today"
        [required]="true"
        ></lib-datepicker>
      </div>
      <div class="form-group">
        <label for="issuer">Emisor</label>
        <custom-select
          [(ngModel)]="_communicationIssuer"
          [bordered]="true"
          name="issuer"
          id="issuer"
          (click)="_errorBackEnd = ''"
          [(sourceList)]="_communicationIssuerList"
          required>
        </custom-select>
      </div>
      <div class="form-group">
        <label for="communicationType">Tipo</label>
        <custom-select
          [(ngModel)]="_communicationTypes"
          [bordered]="true"
          name="communicationType"
          id="communicationType"
          (click)="_errorBackEnd = ''"
          [(sourceList)]="_communicationTypeList"
          required>
        </custom-select>
      </div>
      <div class="form-group" style="min-width: 100%;">
        <label for="description">Comunicado</label>
        <textarea
          type="text"
          maxlength="500"
          name="description"
          rows="3"
          (click)="_errorBackEnd = ''"
          [(ngModel)]="_communication.Description"
          class="form-control" 
          id="description" 
          [placeholder]="'Comunicado'"
          required
        ></textarea>
      </div>
      <div class="form-group" >
        <label for="vialAxis">Eje</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="vialAxis"
          id="vialAxis"
          [disabled]="!_roadway?.value"
          (click)="_errorBackEnd = ''"
          [(ngModel)]="_vialAxes"
          [(sourceList)]="_vialAxesList"
          required>
        </custom-select>
      </div>
      <div class="form-group">
        <label for="kilometer">PK</label>
        <input
          type="number"
          [(ngModel)]="_communication.KilometerPoint"
          (click)="_errorBackEnd = ''"
          class="form-control"
          id="kilometer"
          name="kilometer"
          lang="en"
          required/>
      </div>
      <div class="form-group">
        <label for="trafficDirections">Calzada</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="trafficDirections"
          id="trafficDirections"
          [(ngModel)]="_trafficDirections"
          [(sourceList)]="_trafficDirectionsList"
          required>
        </custom-select>
      </div>
      <div class="form-group" >
        <label for="roadway">Vía</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="roadway"
          id="roadway"
          [disabled]="!_roadwayList.length"
          (click)="_errorBackEnd = ''"
          [(ngModel)]="_roadway"
          [(sourceList)]="_roadwayList"
          required
        ></custom-select>
      </div>
      <div class="form-group" >
        <label for="subSector">Sector</label>
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="subSector"
          id="subSector"
          (click)="_errorBackEnd = ''"
          [(ngModel)]="_subSector"
          [(sourceList)]="_subSectorList"
          required
        ></custom-select>
      </div>
    </div>
  </form>
</generic-page>
